import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import { createAxiosInstance } from "../axiosSettings";

// Initial state
const initialState = {
  token: null,
  isLoading: false,
  isLoggedIn: false, // added
  after_login_data: null, // use null instead of []
  email: null,
  login_error: null,
};

// Actions
export const LOGIN_ACTION = "admin/auth/login";

// LOGIN
export const LoginUser = createAsyncThunk(
  LOGIN_ACTION,
  async (loginData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.post(LOGIN_ACTION, loginData);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Invalid Credentials");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Invalid Credentials"
      );
    }
  }
);

// export const updatePermissionsInState = createAsyncThunk(
//   LOGIN_ACTION + '/perm',
//   async (data, { rejectWithValue }) => {
//     try {
//       const dt = 'qwe';
//       console.log(dt)
//     } catch (error) {
//       return rejectWithValue(
//         error.response?.data || "Invalid Credentials"
//       );
//     }
//   }
// )

// Slice
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout(state) {
      state.token = null;
      state.isLoading = false;
      state.isLoggedIn = false;
      state.after_login_data = null;
      state.login_error = null;
      state.email = null;
      localStorage.removeItem("token"); // optional
    },
    updatePermissionsInState(state, action) {
      const { _id, permissionIds } = action.payload;
      if (
        state.after_login_data?.data.role._id === _id
      ) {
        state.after_login_data.data.role.permissions = permissionIds;
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(LoginUser.pending, (state) => {
        state.isLoading = true;
        state.login_error = null;
      })
      .addCase(LoginUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.after_login_data = action.payload;
        state.token = action.payload.token;
        state.isLoggedIn = true;
      })

      .addCase(LoginUser.rejected, (state, action) => {
        state.isLoading = false;
        state.login_error = action.payload;
      });
  },
});

export const { logout, updatePermissionsInState } = authSlice.actions;
export default authSlice.reducer;
